<template> 
</template>
<script>
export default {
  name: "Access",
  beforeMount() {
    this.setToken();
  },
  methods: {
    async setToken() {
      let { access_token, return_url } = this.$route.query;
      await this.$store.dispatch("auth/setToken", access_token); 
      await this.$store.dispatch('auth/getUser');
      window.location.href =  return_url;
    },
  },
};
</script>